(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bvj-sartoria-calculator"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bvj-sartoria-calculator')){
  customElements.define('bvj-sartoria-calculator',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.saleUnit=this.dataset.saleUnit;this.isPiece=this.saleUnit==='stuk';
      this.config=JSON.parse(this.querySelector('[data-tile-config]').textContent);
      this.variants=JSON.parse(this.querySelector('[data-tile-variants]').textContent);
      this.variant=this.variants.find(v=>String(v.id)===this.dataset.variantId);
      this.area=this.querySelector('[data-tile-area]');this.waste=this.querySelector('[data-tile-waste]');this.add=this.querySelector('[data-tile-add]');this.error=this.querySelector('[data-tile-error]');
      this.selects=Array.from(this.querySelectorAll('[data-tile-option]'));
      this.money=new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'});this.number=new Intl.NumberFormat('nl-NL',{maximumFractionDigits:this.saleUnit==='vel'?6:3});
      const params=new URL(location.href).searchParams;if(params.has('tile_m2'))this.area.value=params.get('tile_m2');this.waste.checked=!this.isPiece&&params.get('tile_waste')==='1';
      this.selects.forEach((s,i)=>s.addEventListener('change',()=>this.choose(i)));
      this.area.addEventListener('input',()=>this.calculate());this.waste.addEventListener('change',()=>this.calculate());this.add.addEventListener('click',()=>this.submit());
      this.updateOptions();this.calculate();
    }
    updateOptions(){
      this.selects.forEach((s,i)=>{for(const o of s.options){o.disabled=!this.variants.some(v=>v.options[i]===o.value&&v.options.slice(0,i).every((x,j)=>x===this.selects[j].value));}});
    }
    choose(index){
      const choices=this.selects.map(s=>s.value);
      const candidates=this.variants.filter(v=>v.options.slice(0,index+1).every((x,i)=>x===choices[i]));
      const ranked=candidates.map(v=>({v,score:v.options.reduce((n,x,i)=>n+(x===choices[i]?1:0),0)})).sort((a,b)=>b.score-a.score);
      if(!ranked.length)return;
      this.add.disabled=true;
      const url=new URL(location.href);url.searchParams.set('variant',ranked[0].v.id);url.searchParams.set('tile_m2',this.area.value);url.searchParams.set('tile_waste',this.waste.checked?'1':'0');
      location.assign(url.toString());
    }
    setText(selector,value){this.querySelector(selector).textContent=value;}
    calculate(){
      this.boxes=0;this.error.hidden=true;
      const row=this.config.rows[this.variant?.sku];const raw=this.area.value.trim();
      const valid=(this.isPiece?/^\d+$/:/^\d+(?:[.,]\d{1,6})?$/).test(raw);const area=valid?Number(raw.replace(',','.')):NaN;
      if(!row||!Number.isFinite(area)||area<=0||area>100000){this.invalid(this.add.dataset.invalid);return;}
      const areaUnits=Math.round(area*1000000),boxUnits=Math.round(Number(row.area)*1000000);
      if(!Number.isSafeInteger(boxUnits)||boxUnits<=0||!Number.isSafeInteger(this.variant.price)||this.variant.price<=0){this.invalid(this.add.dataset.unavailable);return;}
      const wasteFactor=!this.isPiece&&this.waste.checked?110:100;
      const boxes=Math.ceil(areaUnits*wasteFactor/(boxUnits*100));
      if(!Number.isSafeInteger(boxes)||boxes<1||boxes>10000){this.invalid(this.add.dataset.invalid);return;}
      this.boxes=boxes;
      this.setText('[data-tile-delivered]',this.isPiece?String(boxes)+' stuks':this.number.format(boxes*boxUnits/1000000)+' m²');this.setText('[data-tile-boxes]',String(boxes));this.setText('[data-tile-total]',this.money.format(boxes*this.variant.price/100));
      this.add.textContent=boxes===1?this.add.dataset.one:this.add.dataset.label.replace('[aantal]',boxes);this.add.disabled=this.busy||!this.variant.available;
      this.area.setAttribute('aria-invalid','false');
      if(!this.variant.available){this.error.textContent=this.add.dataset.unavailable;this.error.hidden=false;}
    }
    invalid(message){this.add.disabled=true;this.error.textContent=message;this.error.hidden=false;this.area.setAttribute('aria-invalid','true');this.setText('[data-tile-delivered]','—');this.setText('[data-tile-boxes]','—');this.setText('[data-tile-total]','—');}
    async submit(){
      if(this.busy)return;this.calculate();if(!this.boxes||this.add.disabled)return;
      this.busy=true;this.add.disabled=true;this.add.textContent=this.add.dataset.busy;
      const row=this.config.rows[this.variant.sku];
      try{
        const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:this.boxes,properties:this.isPiece?{'Verkoopeenheid':'Stuk'}:{'Verkoopeenheid':this.saleUnit==='vel'?'Mozaïekvel':'Doos','Inhoud per eenheid':this.number.format(Number(row.area))+' m²'}}]})});
        const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.add.dataset.failed);
        location.assign(this.dataset.cartUrl);
      }catch(error){this.busy=false;this.calculate();this.error.textContent=error.message||this.add.dataset.failed;this.error.hidden=false;}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bvj-tile-calculator"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bvj-tile-calculator')){
  customElements.define('bvj-tile-calculator',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.config=JSON.parse(this.querySelector('[data-tile-config]').textContent);
      this.variants=JSON.parse(this.querySelector('[data-tile-variants]').textContent);
      this.variant=this.variants.find(v=>String(v.id)===this.dataset.variantId);
      this.area=this.querySelector('[data-tile-area]');this.waste=this.querySelector('[data-tile-waste]');this.add=this.querySelector('[data-tile-add]');this.error=this.querySelector('[data-tile-error]');
      this.selects=Array.from(this.querySelectorAll('[data-tile-option]'));
      this.money=new Intl.NumberFormat('nl-NL',{style:'currency',currency:'EUR'});this.number=new Intl.NumberFormat('nl-NL',{maximumFractionDigits:6});
      const params=new URL(location.href).searchParams;if(params.has('tile_m2'))this.area.value=params.get('tile_m2');this.waste.checked=params.get('tile_waste')==='1';
      this.selects.forEach((s,i)=>s.addEventListener('change',()=>this.choose(i)));
      this.area.addEventListener('input',()=>this.calculate());this.waste.addEventListener('change',()=>this.calculate());this.add.addEventListener('click',()=>this.submit());
      this.updateOptions();this.calculate();
    }
    updateOptions(){
      this.selects.forEach((s,i)=>{for(const o of s.options){o.disabled=!this.variants.some(v=>v.options[i]===o.value&&v.options.slice(0,i).every((x,j)=>x===this.selects[j].value));}});
    }
    choose(index){
      const choices=this.selects.map(s=>s.value);
      const candidates=this.variants.filter(v=>v.options.slice(0,index+1).every((x,i)=>x===choices[i]));
      const ranked=candidates.map(v=>({v,score:v.options.reduce((n,x,i)=>n+(x===choices[i]?1:0),0)})).sort((a,b)=>b.score-a.score);
      if(!ranked.length)return;
      this.add.disabled=true;
      const url=new URL(location.href);url.searchParams.set('variant',ranked[0].v.id);url.searchParams.set('tile_m2',this.area.value);url.searchParams.set('tile_waste',this.waste.checked?'1':'0');
      location.assign(url.toString());
    }
    setText(selector,value){this.querySelector(selector).textContent=value;}
    calculate(){
      this.boxes=0;this.error.hidden=true;
      const row=this.config.rows[this.variant?.sku];const raw=this.area.value.trim();
      const valid=/^\d+(?:[.,]\d{1,6})?$/.test(raw);const area=valid?Number(raw.replace(',','.')):NaN;
      if(!row||!Number.isFinite(area)||area<=0||area>100000){this.invalid(this.add.dataset.invalid);return;}
      const areaUnits=Math.round(area*1000000),boxUnits=Math.round(Number(row.area)*1000000);
      if(!Number.isSafeInteger(boxUnits)||boxUnits<=0||!Number.isSafeInteger(this.variant.price)||this.variant.price<=0){this.invalid(this.add.dataset.unavailable);return;}
      const wasteFactor=this.waste.checked?110:100;
      const boxes=Math.ceil(areaUnits*wasteFactor/(boxUnits*100));
      if(!Number.isSafeInteger(boxes)||boxes<1||boxes>10000){this.invalid(this.add.dataset.invalid);return;}
      this.boxes=boxes;
      this.setText('[data-tile-delivered]',this.number.format(boxes*boxUnits/1000000)+' m²');this.setText('[data-tile-boxes]',String(boxes));this.setText('[data-tile-total]',this.money.format(boxes*this.variant.price/100));
      this.add.textContent=boxes===1?this.add.dataset.one:this.add.dataset.label.replace('[aantal]',boxes);this.add.disabled=this.busy||!this.variant.available;
      this.area.setAttribute('aria-invalid','false');
      if(!this.variant.available){this.error.textContent=this.add.dataset.unavailable;this.error.hidden=false;}
    }
    invalid(message){this.add.disabled=true;this.error.textContent=message;this.error.hidden=false;this.area.setAttribute('aria-invalid','true');this.setText('[data-tile-delivered]','—');this.setText('[data-tile-boxes]','—');this.setText('[data-tile-total]','—');}
    async submit(){
      if(this.busy)return;this.calculate();if(!this.boxes||this.add.disabled)return;
      this.busy=true;this.add.disabled=true;this.add.textContent=this.add.dataset.busy;
      const row=this.config.rows[this.variant.sku];
      try{
        const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:this.boxes,properties:{'Verkoopeenheid':this.dataset.unit==='mat'?'Mat':'Doos',[this.dataset.unitArea]:this.number.format(Number(row.area))+' m²'}}]})});
        const result=await response.json();if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.add.dataset.failed);
        location.assign(this.dataset.cartUrl);
      }catch(error){this.busy=false;this.calculate();this.error.textContent=error.message||this.add.dataset.failed;this.error.hidden=false;}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bvj-tile-product-layout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bvj-tile-description')) {
  customElements.define('bvj-tile-description', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const button = this.querySelector('button');
      const content = this.querySelector('.product-description__body-content');
      const label = button.querySelector('[data-toggle-label]');
      this.dataset.ready = 'true';
      const limit = parseFloat(getComputedStyle(content).maxHeight);
      const update = () => {
        const open = this.classList.contains('is-open');
        button.hidden = !open && content.scrollHeight <= limit + 2;
        button.setAttribute('aria-expanded', String(open));
        label.textContent = open ? button.dataset.collapse : button.dataset.expand;
      };
      button.addEventListener('click', () => { this.classList.toggle('is-open'); update(); });
      this.observer = new ResizeObserver(update);
      this.observer.observe(content);
      document.fonts.ready.then(update);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["martens-meubel-configurator"] && !Shopify.designMode) return;
  try {
    class MMFurniture extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.data = JSON.parse(this.querySelector('[data-mm-data]').textContent);
    this.labels = JSON.parse(this.querySelector('[data-mm-labels]').textContent);
    this.format = new Intl.NumberFormat(this.dataset.locale || 'nl', {style: 'currency', currency: this.dataset.currency || 'EUR'});
    this.cabinets = this.data.cabinet.variants;
    this.basins = this.data.basins.filter(Boolean).flatMap(p => p.variants.map(v => ({...v, handle:p.handle, url:p.url})));
    const params = new URL(location.href).searchParams;
    const requested=this.data.legacy?.[params.get('variant')] || params.get('variant') || this.dataset.selected;
    this.cabinet = this.cabinets.find(v => String(v.id) === String(requested)) || this.cabinets.find(v=>String(v.id)===this.dataset.selected) || this.cabinets.find(v => v.available) || this.cabinets[0];
    this.basin = this.compatible().find(v => String(v.id) === params.get('mm_basin')) || null;
    this.tall = this.matchingTall()?.id.toString() === params.get('mm_tall') ? this.matchingTall() : null;
    this.querySelector('[data-quantity]').addEventListener('input', () => this.renderSummary());
    this.querySelector('[data-add]').addEventListener('click', () => this.add());
    this.sticky=this.querySelector('[data-sticky]');document.body.append(this.sticky);
    this.sticky.querySelector('[data-sticky-add]').addEventListener('click', () => this.add());
    this.render();
    this.hidden = false;
    this.stickyObserver=new IntersectionObserver(()=>this.updateSticky());
    this.stickyObserver.observe(this.querySelector('[data-add]'));
    this.stickyObserver.observe(this.querySelector('.mm-config__head'));
    this.onScroll=()=>this.updateSticky();window.addEventListener('scroll',this.onScroll,{passive:true});
    this.onPageshow=e=>{if(e.persisted){this.busy=false;this.querySelector('[data-quantity]').disabled=false;this.querySelector('[data-add]').textContent=this.labels.add;this.render();this.updateSticky();}};
    window.addEventListener('pageshow',this.onPageshow);
    this.updateSticky();
  }
  disconnectedCallback(){this.photoPanel?.remove();this.closest('product-info')?.querySelector('media-gallery')?.classList.remove('mm-cabinet-gallery');this.sticky?.remove();this.stickyObserver?.disconnect();window.removeEventListener('scroll',this.onScroll);window.removeEventListener('pageshow',this.onPageshow);}
  updateSticky(){const box=this.querySelector('[data-add]').getBoundingClientRect();this.sticky.hidden=!(this.getBoundingClientRect().top<0 && (box.bottom<0 || box.top>innerHeight));}
  money(cents) { return this.format.format(cents / 100); }
  dimensions(v) { return v.options[0].split(/[×x]/).map(n => Number.parseFloat(n.trim())); }
  color(v) { return v.color || v.options.find(o=>!/\d/.test(o)) || 'Cashmere'; }
  drawers(v) { return v.sku.startsWith('2x') ? 4 : 2; }
  matchingBoard() {
    const [w,d]=this.dimensions(this.cabinet);
    if(this.data.board?.handle!==`martens-meijer-${this.data.series}-afdekplaat`)return null;
    const v=this.data.board.variants.find(v=>v.available && v.price>0 && this.dimensions(v)[0]===w && this.dimensions(v)[1]===d && this.color(v)===this.color(this.cabinet));
    return v ? {...v,kind:'board',handle:this.data.board.handle,url:this.data.board.url} : null;
  }
  compatible() {
    const [w,d] = this.dimensions(this.cabinet);
    return [this.matchingBoard(),...this.basins.filter(v => {
      const [bw,bd] = this.dimensions(v);
      return v.available && v.price > 0 && w === bw && d === bd && !(v.sku === '9101006' && this.cabinet.sku.startsWith('2x'));
    })].filter(Boolean);
  }
  tapHoles(v) { return Number(v?.options.find(o => /^[12] kraangat/.test(o))?.[0] || 0); }
  sameBasin(a,b) { return Boolean(a && b && a.kind!=='board' && b.kind!=='board' && a.sku===b.sku && a.handle===b.handle); }
  renderTapHoles() {
    const area=this.querySelector('[data-tap-holes]');
    const choices=this.querySelector('[data-tap-hole-choices]');choices.replaceChildren();
    area.hidden=!this.basin || this.basin.kind==='board';
    if(area.hidden)return;
    const variants=this.compatible().filter(v=>this.sameBasin(v,this.basin)).sort((a,b)=>this.tapHoles(a)-this.tapHoles(b));
    const base=variants.find(v=>this.tapHoles(v)===0);
    variants.forEach(v=>{
      const count=this.tapHoles(v), title=this.labels['holes_'+count];
      const extra=v.price-(base?.price || v.price);
      const radio=this.radio('tap-holes',String(count),v.id===this.basin.id,`${title} · ${extra?'+ '+this.money(extra):this.labels.holes_free}`,()=>{this.basin=v;this.renderTapHoles();this.renderSummary();this.updateURL();},'mm-config__width mm-config__hole');
      const body=this.node('span');body.append(this.node('strong','',title),this.node('small','',extra?'+ '+this.money(extra):this.labels.holes_free));radio.append(body);choices.append(radio);
    });
    this.querySelector('[data-tap-hole-note]').textContent=this.basin.sku==='9101006'?this.labels.holes_large:this.labels.holes_note;
  }
  matchingTall() { return this.data.tall?.variants.find(v => v.available && v.price > 0 && (v.options.includes(this.color(this.cabinet)) || (this.color(this.cabinet) === 'Cashmere' && this.data.tall.variants.length === 1))); }
  node(tag, className, text) {
    const n = document.createElement(tag);
    if (className) n.className = className;
    if (text !== undefined) n.textContent = text;
    return n;
  }
  radio(group, value, checked, label, callback, className = '') {
    const outer = this.node('label', `mm-config__choice ${className}`);
    const input = document.createElement('input');
    input.type = 'radio'; input.name = `mm-${this.dataset.section}-${group}`; input.value = value; input.checked = checked;
    input.setAttribute('aria-label', label);
    input.addEventListener('change', callback);
    outer.append(input);
    return outer;
  }
  changeCabinet(next) {
    if (!next) return;
    const previousBasin = this.basin;
    const previousTall = this.tall;
    this.cabinet = next;
    if (this.basin && !this.compatible().some(v => v.id === this.basin.id)) this.basin = null;
    if (this.tall && this.matchingTall()?.id !== this.tall.id) this.tall = null;
    this.render();
    if ((previousBasin && !this.basin) || (previousTall && !this.tall)) {
      const notice = this.querySelector('[data-notice]');
      notice.textContent = previousBasin && !this.basin ? this.labels.changed : this.labels.tall_reset;
      notice.hidden = false;
    }
    this.updateURL();

  }
  renderCabinetPhoto() {
    const gallery=this.closest('product-info')?.querySelector('media-gallery');
    if(!gallery)return;
    if(!this.photoPanel){
      this.photoPanel=this.node('figure','mm-cabinet-photo');
      this.photoImage=this.node('img');this.photoImage.width=1600;this.photoImage.height=1200;
      this.photoImage.decoding='async';
      this.photoCaption=this.node('figcaption');
      this.photoChoice=this.node('strong');
      this.photoStatus=this.node('p');this.photoStatus.setAttribute('role','status');
      this.photoSwatch=this.node('img','mm-cabinet-photo__swatch');this.photoSwatch.width=48;this.photoSwatch.height=48;
      const info=this.node('div');info.append(this.photoChoice,this.photoStatus);
      this.photoCaption.append(this.photoSwatch,info);
      this.photoPanel.append(this.photoImage,this.photoCaption);gallery.prepend(this.photoPanel);
      gallery.classList.add('mm-cabinet-gallery');
      this.photoImage.addEventListener('error',()=>{this.photoImage.hidden=true;this.photoStatus.textContent=this.labels.photo_missing;});
    }
    const v=this.cabinet,drawers=this.drawers(v),color=this.color(v);
    const candidates=(this.data.photos[this.data.series] || []).filter(p=>p.drawers===drawers);
    const photo=candidates.find(p=>p.color===color) || candidates[0];
    const exact=Boolean(v.photoExact && v.photo);
    const source=exact?v.photo:photo?.url;
    const sameColor=photo?.color===color;
    const choice=`${this.data.series.toUpperCase()} · ${v.options.join(' · ')}`;
    const status=!source?this.labels.photo_missing:exact?this.labels.photo_exact:sameColor?this.labels.photo_drawers_color:this.labels.photo_drawers;
    this.photoChoice.textContent=choice;
    this.photoStatus.textContent=status.replace('{drawers}',String(drawers));
    this.photoImage.alt=exact?choice:`${this.data.series.toUpperCase()} · ${drawers} ${this.labels.drawers_unit}${sameColor?' · '+color:''}`;
    this.photoImage.hidden=!source;
    if(source && this.photoImage.getAttribute('src')!==source)this.photoImage.src=source;
    if(!source)this.photoImage.removeAttribute('src');
    this.photoSwatch.src=this.data.swatches[color] || v.image;
    this.photoSwatch.alt=`${this.labels.color_sample}: ${color}`;
    this.photoPanel.dataset.variant=String(v.id);
    this.photoPanel.dataset.exact=String(exact);
    this.photoPanel.dataset.drawers=String(drawers);
  }
  render() {
    this.renderCabinetPhoto();
    const widthContainer = this.querySelector('[data-widths]');
    widthContainer.replaceChildren();
    const currentWidth = this.dimensions(this.cabinet)[0];
    [...new Set(this.cabinets.map(v => this.dimensions(v)[0]))].sort((a,b) => a-b).forEach(width => {
      const matching=this.cabinets.filter(v=>this.dimensions(v)[0]===width && v.available);
      const next = matching.find(v=>this.color(v)===this.color(this.cabinet) && this.drawers(v)===this.drawers(this.cabinet)) || matching.find(v=>this.color(v)===this.color(this.cabinet)) || matching[0];
      const radio = this.radio('width', String(width), width === currentWidth, `${width} cm`, () => this.changeCabinet(next), 'mm-config__width');
      radio.querySelector('input').disabled = !next;
      radio.append(this.node('span', '', `${width} cm`)); widthContainer.append(radio);
    });
    const drawers=this.querySelector('[data-drawers]');drawers.replaceChildren();
    [2,4].forEach(count=>{
      const next=this.cabinets.find(v=>this.dimensions(v)[0]===currentWidth && this.drawers(v)===count && this.color(v)===this.color(this.cabinet) && v.available);
      const label=this.radio('drawers',String(count),this.drawers(this.cabinet)===count,`${count} ${this.labels.drawers_unit}`,()=>this.changeCabinet(next),'mm-config__width mm-config__drawer');
      label.querySelector('input').disabled=!next;
      const body=this.node('span');body.append(this.node('strong','',`${count} ${this.labels.drawers_unit}`),this.node('small','',count===2?this.labels.one_cabinet:this.labels.two_cabinets));label.append(body);drawers.append(label);
    });
    const colors = this.querySelector('[data-colors]'); colors.replaceChildren();
    this.cabinets.filter(v => this.dimensions(v)[0] === currentWidth && this.drawers(v)===this.drawers(this.cabinet)).forEach(v => {
      const color = this.color(v);
      const label = this.radio('color', color, v.id === this.cabinet.id, color, () => this.changeCabinet(v), 'mm-config__color');
      label.querySelector('input').disabled = !v.available;
      const chip = this.node('span', 'mm-config__swatch'); chip.dataset.color = color;
      const swatch=this.data.swatches?.[color];if(swatch)chip.style.backgroundImage=`url("${swatch}")`;
      const body = this.node('span', 'mm-config__color-inner'); body.append(chip,this.node('span','',color));label.append(body);colors.append(label);
    });
    this.querySelector('[data-dimensions]').textContent = `${this.cabinet.options[0]}${this.cabinet.sku.startsWith('2x') ? ' · '+this.labels.assembly : ''}`;
    this.querySelector('[data-finish]').textContent = this.color(this.cabinet);
    this.querySelector('[data-cabinet-price]').textContent = this.money(this.cabinet.price);
    const photo = this.querySelector('[data-cabinet-image]'); photo.src = this.data.swatches?.[this.color(this.cabinet)] || this.cabinet.image; photo.alt = `${this.labels.color_sample} ${this.color(this.cabinet)}`;
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    if (sku) { sku.replaceChildren(this.node('span','',`${this.labels.article}: ${this.cabinet.sku}${this.cabinet.barcode ? ' · EAN: '+this.cabinet.barcode : ''}`)); }
    this.querySelector('[data-exception]').hidden = !(currentWidth === 120 && this.cabinet.sku.startsWith('2x'));
    this.querySelector('[data-notice]').hidden = true;
    const basins = this.querySelector('[data-basins]'); basins.replaceChildren();
    const none = this.radio('basin','none',!this.basin,this.labels.none,()=>{this.basin=null;this.render();this.updateURL();},'mm-config__basin mm-config__basin--none');
    const noneBody = this.node('span','mm-config__card-body');noneBody.append(this.node('strong','',this.labels.none),this.node('small','',this.labels.none_note)); none.append(noneBody);basins.append(none);
    this.compatible().filter(v=>this.tapHoles(v)===0).forEach(v => {
      const title = this.basinTitle(v);
      const card = this.radio('basin',String(v.id),(this.basin?.id === v.id || this.sameBasin(this.basin,v)),`${title} · ${this.money(v.price)}`,()=>{this.basin=v;this.render();this.updateURL();},'mm-config__basin');
      const img = document.createElement('img');img.src=v.image;img.alt=title;img.loading='lazy';img.width=120;img.height=100;
      const material=v.kind==='board'?this.labels.board_note:(v.handle.includes('arq') ? this.labels.solid : this.labels.ceramic);
      const body=this.node('span','mm-config__card-body');body.append(this.node('strong','',title),this.node('small','',`${v.options.filter(o=>!(/kraangat|kraangaten/.test(o))).join(' · ')} · ${material}`),this.node('b','',`+ ${this.money(v.price)}`));
      card.append(img,body,this.node('span','mm-config__tick','✓'));basins.append(card);
    });
    if(!this.compatible().length)basins.append(this.node('p','mm-config__hint',this.labels.empty));
    this.renderTapHoles();
    const tallContainer=this.querySelector('[data-tall]');tallContainer.replaceChildren();
    const tall=this.matchingTall();
    if(tall){
      const label=this.node('label','mm-config__tall');const input=document.createElement('input');input.type='checkbox';input.checked=Boolean(this.tall);input.setAttribute('aria-label',`${this.labels.tall_short} ${this.color(this.cabinet)}`);input.addEventListener('change',()=>{this.tall=input.checked?tall:null;this.renderSummary();this.updateURL();});
      const img=document.createElement('img');img.src=tall.image;img.alt=this.data.tall.title;img.width=64;img.height=80;img.loading='lazy';
      const body=this.node('span','mm-config__card-body');body.append(this.node('strong','',this.data.tall.title.replace('Martens & Meijer ','')),this.node('small','',tall.title),this.node('b','',`+ ${this.money(tall.price)}`));label.append(input,img,body);tallContainer.append(label);
    }else tallContainer.append(this.node('p','mm-config__hint',this.labels.unavailable));
    this.renderSummary();
  }
  basinTitle(v) { if(v.kind==='board')return `${this.data.series[0].toUpperCase()+this.data.series.slice(1)} · ${this.labels.board}`; return `${v.handle.includes('arq')?'Arq':'Lume'} · ${v.handle.includes('asymmetrisch') ? this.labels.asym : v.handle.includes('dubbel') ? this.labels.double : this.labels.single}`; }
  renderSummary() {
    const summary=this.querySelector('[data-summary]');summary.replaceChildren();
    const rows=[[this.labels.cabinet, this.cabinet, `${this.cabinet.options.join(' · ')}`]];
    if(this.basin)rows.push([this.basin.kind==='board'?this.labels.board:this.labels.basin_short,this.basin,this.basinTitle(this.basin)+(this.basin.kind==='board'?'':' · '+this.labels['holes_'+this.tapHoles(this.basin)])]);
    if(this.tall)rows.push([this.labels.tall_short,this.tall,this.color(this.cabinet)]);
    rows.forEach(([name,v,detail])=>{const row=this.node('div');const dt=this.node('dt','',name);dt.append(this.node('small','',detail));row.append(dt,this.node('dd','',this.money(v.price)));summary.append(row);});
    const quantityInput=this.querySelector('[data-quantity]');const quantity=quantityInput.valueAsNumber;
    this.querySelector('[data-total]').textContent=this.money(rows.reduce((sum,row)=>sum+row[1].price,0)*(Number.isInteger(quantity)&&quantity>0?quantity:1));
    this.querySelector('[data-add]').disabled = Boolean(this.busy) || !this.cabinet.available || !quantityInput.validity.valid || !Number.isInteger(quantity);
    this.sticky.querySelector('[data-sticky-total]').textContent=this.querySelector('[data-total]').textContent;
    this.sticky.querySelector('[data-sticky-choice]').textContent=`${this.cabinet.options.join(' · ')}${this.basin?' + '+this.basinTitle(this.basin):''}`;
    this.sticky.querySelector('[data-sticky-add]').disabled=this.querySelector('[data-add]').disabled;
  }
  updateURL() {
    const url=new URL(location.href);url.searchParams.set('variant',this.cabinet.id);
    this.basin?url.searchParams.set('mm_basin',this.basin.id):url.searchParams.delete('mm_basin');
    this.tall?url.searchParams.set('mm_tall',this.tall.id):url.searchParams.delete('mm_tall');
    history.replaceState({},'',url);
  }
  async add() {
    if(this.busy)return;
    const input=this.querySelector('[data-quantity]');if(!input.reportValidity())return;
    if(!this.cabinet.available || (this.basin && !this.compatible().some(v=>v.id===this.basin.id)) || (this.tall && this.tall.id!==this.matchingTall()?.id))return;
    this.busy=true;const button=this.querySelector('[data-add]');button.disabled=true;button.textContent=this.labels.adding;
    this.sticky.querySelector('[data-sticky-add]').disabled=true;
    const error=this.querySelector('[data-error]');error.hidden=true;
    this.querySelectorAll('input').forEach(i=>i.disabled=true);
    const root=window.Shopify?.routes?.root || '/';
    const items=[this.cabinet,this.basin,this.tall].filter(Boolean).map(v=>({id:v.id,quantity:input.valueAsNumber}));
    if(this.basin && this.tapHoles(this.basin)>0){
      const line=items.find(v=>v.id===this.basin.id);
      line.properties={'Bewerking':`${this.tapHoles(this.basin)} × kraangat (0102001)`};
    }
    try{
      const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if(!response.ok)throw new Error('cart');
      const result=await response.json();if(!result.items?.length)throw new Error('cart');
      location.assign(`${root}cart`);
    }catch{
      this.busy=false;this.render();input.disabled=false;
      button.textContent=this.labels.add;error.textContent=this.labels.error;error.hidden=false;
    }
  }
}
if(!customElements.get('mm-furniture'))customElements.define('mm-furniture',MMFurniture);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["regn-meubel-configurator"] && !Shopify.designMode) return;
  try {
    class RegnFurniture extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.data = JSON.parse(this.querySelector('[data-regn-mm-data]').textContent);
    this.labels = JSON.parse(this.querySelector('[data-regn-mm-labels]').textContent);
    this.format = new Intl.NumberFormat(this.dataset.locale || 'nl', {style: 'currency', currency: this.dataset.currency || 'EUR'});
    this.cabinets = this.data.cabinet.variants;
    this.basins = [];
    const boardWidths={'regn-20065':60,'regn-20075':70,'regn-20085':80,'regn-20105':100,'regn-20125':120};
    this.boards=this.data.boards.filter(Boolean).flatMap(p=>p.variants.map(v=>({...v,width:boardWidths[p.handle],kind:'board',handle:p.handle,url:p.url})));
    this.tallVariants=this.data.tall?.variants || [];
    const params = new URL(location.href).searchParams;
    const requested=this.data.legacy?.[params.get('variant')] || params.get('variant') || this.dataset.selected;
    this.cabinet = this.cabinets.find(v => String(v.id) === String(requested)) || this.cabinets.find(v=>String(v.id)===this.dataset.selected) || this.cabinets.find(v => v.available) || this.cabinets[0];
    this.basin = this.compatible().find(v => String(v.id) === params.get('regn_board')) || null;
    this.tall = this.matchingTalls().find(v=>String(v.id)===params.get('regn_tall')) || null;
    this.querySelector('[data-quantity]').addEventListener('input', () => this.renderSummary());
    this.querySelector('[data-add]').addEventListener('click', () => this.add());
    this.sticky=this.querySelector('[data-sticky]');document.body.append(this.sticky);
    this.sticky.querySelector('[data-sticky-add]').addEventListener('click', () => this.add());
    this.render();
    this.hidden = false;
    this.stickyObserver=new IntersectionObserver(()=>this.updateSticky());
    this.stickyObserver.observe(this.querySelector('[data-add]'));
    this.stickyObserver.observe(this.querySelector('.regn-mm-config__head'));
    this.onScroll=()=>this.updateSticky();window.addEventListener('scroll',this.onScroll,{passive:true});
    this.onPageshow=e=>{if(e.persisted){this.busy=false;this.querySelector('[data-quantity]').disabled=false;this.querySelector('[data-add]').textContent=this.labels.add;this.render();this.updateSticky();}};
    window.addEventListener('pageshow',this.onPageshow);
    this.updateSticky();
  }
  disconnectedCallback(){this.specsRequest?.abort();this.photoPanel?.remove();this.closest('product-info')?.querySelector('media-gallery')?.classList.remove('regn-mm-cabinet-gallery');this.sticky?.remove();this.stickyObserver?.disconnect();window.removeEventListener('scroll',this.onScroll);window.removeEventListener('pageshow',this.onPageshow);}
  updateSticky(){const box=this.querySelector('[data-add]').getBoundingClientRect();this.sticky.hidden=!(this.getBoundingClientRect().top<0 && (box.bottom<0 || box.top>innerHeight));}
  money(cents) { return this.format.format(cents / 100); }
  dimensions(v) { return v.options[0].split(/[×x]/).map(n => Number.parseFloat(n.trim())); }
  color(v) { return v.color || v.options[v.options.length-1]; }
  drawers(v) { return Number.parseInt(v.options[1],10); }
  matchingBoard() {
    const width=this.dimensions(this.cabinet)[0], color=this.color(this.cabinet).replace(/ ribbel$/,'');
    return this.boards.find(v=>v.available && v.price>0 && v.width===width && this.color(v)===color) || null;
  }
  compatible() { return [this.matchingBoard()].filter(Boolean); }
  tapHoles(v) { return Number(v?.options.find(o => /^[12] kraangat/.test(o))?.[0] || 0); }
  sameBasin(a,b) { return Boolean(a && b && a.kind!=='board' && b.kind!=='board' && a.sku===b.sku && a.handle===b.handle); }
  renderTapHoles() {
    const area=this.querySelector('[data-tap-holes]');
    const choices=this.querySelector('[data-tap-hole-choices]');choices.replaceChildren();
    area.hidden=!this.basin || this.basin.kind==='board';
    if(area.hidden)return;
    const variants=this.compatible().filter(v=>this.sameBasin(v,this.basin)).sort((a,b)=>this.tapHoles(a)-this.tapHoles(b));
    const base=variants.find(v=>this.tapHoles(v)===0);
    variants.forEach(v=>{
      const count=this.tapHoles(v), title=this.labels['holes_'+count];
      const extra=v.price-(base?.price || v.price);
      const radio=this.radio('tap-holes',String(count),v.id===this.basin.id,`${title} · ${extra?'+ '+this.money(extra):this.labels.holes_free}`,()=>{this.basin=v;this.renderTapHoles();this.renderSummary();this.updateURL();},'regn-mm-config__width regn-mm-config__hole');
      const body=this.node('span');body.append(this.node('strong','',title),this.node('small','',extra?'+ '+this.money(extra):this.labels.holes_free));radio.append(body);choices.append(radio);
    });
    this.querySelector('[data-tap-hole-note]').textContent=this.basin.sku==='9101006'?this.labels.holes_large:this.labels.holes_note;
  }
  matchingTalls() { return this.tallVariants.filter(v=>v.available && v.price>0 && this.color(v)===this.color(this.cabinet)); }
  matchingTall() { return this.matchingTalls().find(v=>v.id===this.tall?.id) || this.matchingTalls()[0]; }
  node(tag, className, text) {
    const n = document.createElement(tag);
    if (className) n.className = className;
    if (text !== undefined) n.textContent = text;
    return n;
  }
  radio(group, value, checked, label, callback, className = '') {
    const outer = this.node('label', `regn-mm-config__choice ${className}`);
    const input = document.createElement('input');
    input.type = 'radio'; input.name = `regn-mm-${this.dataset.section}-${group}`; input.value = value; input.checked = checked;
    input.setAttribute('aria-label', label);
    input.addEventListener('change', callback);
    outer.append(input);
    return outer;
  }
  changeCabinet(next) {
    if (!next) return;
    const previousBasin = this.basin;
    const previousTall = this.tall;
    this.cabinet = next;
    if (this.basin && !this.compatible().some(v => v.id === this.basin.id)) this.basin = null;
    if (this.tall && !this.matchingTalls().some(v=>v.id===this.tall.id)) this.tall = null;
    this.render();
    if ((previousBasin && !this.basin) || (previousTall && !this.tall)) {
      const notice = this.querySelector('[data-notice]');
      notice.textContent = previousBasin && !this.basin ? this.labels.changed : this.labels.tall_reset;
      notice.hidden = false;
    }
    this.updateURL();
    this.updateSpecifications();

  }
  async updateSpecifications() {
    const host=this.closest('product-info');if(!host?.updateSpecifications)return;
    this.specsRequest?.abort();this.specsRequest=new AbortController();
    const url=new URL(host.dataset.url,location.origin);url.searchParams.set('variant',this.cabinet.id);url.searchParams.set('section_id',this.dataset.section);
    try{const response=await fetch(url,{signal:this.specsRequest.signal});if(response.ok)host.updateSpecifications(new DOMParser().parseFromString(await response.text(),'text/html'));}catch(error){if(error.name!=='AbortError')console.warn('REGN specifications could not be refreshed');}
  }
  renderCabinetPhoto() {
    const gallery=this.closest('product-info')?.querySelector('media-gallery');
    if(!gallery)return;
    if(!this.photoPanel){
      this.photoPanel=this.node('figure','regn-mm-cabinet-photo');
      this.photoImage=this.node('img');this.photoImage.width=1600;this.photoImage.height=1200;
      this.photoImage.decoding='async';
      this.photoCaption=this.node('figcaption');
      this.photoChoice=this.node('strong');
      this.photoStatus=this.node('p');this.photoStatus.setAttribute('role','status');
      this.photoSwatch=this.node('img','regn-mm-cabinet-photo__swatch');this.photoSwatch.width=48;this.photoSwatch.height=48;
      const info=this.node('div');info.append(this.photoChoice,this.photoStatus);
      this.photoCaption.append(this.photoSwatch,info);
      this.photoPanel.append(this.photoImage,this.photoCaption);gallery.prepend(this.photoPanel);
      gallery.classList.add('regn-mm-cabinet-gallery');
      this.photoImage.addEventListener('error',()=>{this.photoImage.hidden=true;this.photoStatus.textContent=this.labels.photo_missing;});
    }
    const v=this.cabinet,drawers=this.drawers(v),color=this.color(v);
    const candidates=this.cabinets.filter(p=>p.photoExact && p.photo && this.drawers(p)===drawers);
    const fallback=candidates.find(p=>this.dimensions(p)[0]===this.dimensions(v)[0] && this.color(p)===color) || candidates.find(p=>this.color(p)===color) || candidates.find(p=>this.dimensions(p)[0]===this.dimensions(v)[0]) || candidates[0];
    const photo=fallback?{color:this.color(fallback),url:fallback.photo}:null;
    const exact=Boolean(v.photoExact && v.photo);
    const source=exact?v.photo:photo?.url;
    const sameColor=photo?.color===color;
    const choice=`${this.data.series.toUpperCase()} · ${v.options.join(' · ')}`;
    const status=!source?this.labels.photo_missing:exact?this.labels.photo_exact:sameColor?this.labels.photo_drawers_color:this.labels.photo_drawers;
    this.photoChoice.textContent=choice;
    this.photoStatus.textContent=status.replace('{drawers}',String(drawers));
    this.photoImage.alt=exact?choice:`${this.data.series.toUpperCase()} · ${drawers} ${this.labels.drawers_unit}${sameColor?' · '+color:''}`;
    this.photoImage.hidden=!source;
    if(source && this.photoImage.getAttribute('src')!==source)this.photoImage.src=source;
    if(!source)this.photoImage.removeAttribute('src');
    this.photoSwatch.hidden=true;
    this.photoSwatch.alt=`${this.labels.color_sample}: ${color}`;
    this.photoPanel.dataset.variant=String(v.id);
    this.photoPanel.dataset.exact=String(exact);
    this.photoPanel.dataset.drawers=String(drawers);
  }
  render() {
    this.renderCabinetPhoto();
    const widthContainer = this.querySelector('[data-widths]');
    widthContainer.replaceChildren();
    const currentWidth = this.dimensions(this.cabinet)[0];
    [...new Set(this.cabinets.map(v => this.dimensions(v)[0]))].sort((a,b) => a-b).forEach(width => {
      const matching=this.cabinets.filter(v=>this.dimensions(v)[0]===width && v.available);
      const next = matching.find(v=>this.color(v)===this.color(this.cabinet) && this.drawers(v)===this.drawers(this.cabinet)) || matching.find(v=>this.color(v)===this.color(this.cabinet)) || matching[0];
      const radio = this.radio('width', String(width), width === currentWidth, `${width} cm`, () => this.changeCabinet(next), 'regn-mm-config__width');
      radio.querySelector('input').disabled = !next;
      radio.append(this.node('span', '', `${width} cm`)); widthContainer.append(radio);
    });
    const drawers=this.querySelector('[data-drawers]');drawers.replaceChildren();
    [1,2,4].forEach(count=>{
      const matching=this.cabinets.filter(v=>this.dimensions(v)[0]===currentWidth && this.drawers(v)===count && this.color(v)===this.color(this.cabinet) && v.available);
      const next=matching.find(v=>this.dimensions(v)[2]===this.dimensions(this.cabinet)[2]) || matching[0];
      const label=this.radio('drawers',String(count),this.drawers(this.cabinet)===count,`${count} ${count===1?this.labels.drawer_one:this.labels.drawers_unit}`,()=>this.changeCabinet(next),'regn-mm-config__width regn-mm-config__drawer');
      label.querySelector('input').disabled=!next;
      const body=this.node('span');body.append(this.node('strong','',`${count} ${count===1?this.labels.drawer_one:this.labels.drawers_unit}`),this.node('small','',next?`${this.dimensions(next)[2]} cm ${this.labels.height.toLowerCase()}`:this.labels.unavailable));label.append(body);drawers.append(label);
    });
    const heights=this.querySelector('[data-heights]');heights.replaceChildren();
    const heightsAvailable=[...new Set(this.cabinets.filter(v=>this.dimensions(v)[0]===currentWidth && this.drawers(v)===this.drawers(this.cabinet)).map(v=>this.dimensions(v)[2]))];
    this.querySelector('[data-height-step]').hidden=heightsAvailable.length<2;
    heightsAvailable.sort((a,b)=>a-b).forEach(height=>{
      const next=this.cabinets.find(v=>this.dimensions(v)[0]===currentWidth && this.dimensions(v)[2]===height && this.drawers(v)===this.drawers(this.cabinet) && this.color(v)===this.color(this.cabinet) && v.available);
      const label=this.radio('height',String(height),this.dimensions(this.cabinet)[2]===height,`${height} cm`,()=>this.changeCabinet(next),'regn-mm-config__width');
      label.querySelector('input').disabled=!next;label.append(this.node('span','',`${height} cm`));heights.append(label);
    });
    const colors = this.querySelector('[data-colors]'); colors.replaceChildren();
    this.cabinets.filter(v => this.dimensions(v)[0] === currentWidth && this.drawers(v)===this.drawers(this.cabinet) && this.dimensions(v)[2]===this.dimensions(this.cabinet)[2]).forEach(v => {
      const color = this.color(v);
      const label = this.radio('color', color, v.id === this.cabinet.id, color, () => this.changeCabinet(v), 'regn-mm-config__color');
      label.querySelector('input').disabled = !v.available;
      const chip = this.node('span', 'regn-mm-config__swatch'); chip.dataset.color = color;
      const swatch=this.data.swatches?.[color];if(swatch)chip.style.backgroundImage=`url("${swatch}")`;
      const body = this.node('span', 'regn-mm-config__color-inner'); body.append(chip,this.node('span','',color));label.append(body);colors.append(label);
    });
    this.querySelector('[data-dimensions]').textContent = `${this.cabinet.options[0]}${this.cabinet.sku.startsWith('2x') ? ' · '+this.labels.assembly : ''}`;
    this.querySelector('[data-finish]').textContent = this.color(this.cabinet);
    this.querySelector('[data-cabinet-price]').textContent = this.money(this.cabinet.price);
    const photo = this.querySelector('[data-cabinet-image]'); photo.hidden=!this.cabinet.image; if(this.cabinet.image)photo.src=this.cabinet.image; photo.alt = `${this.labels.color_sample} ${this.color(this.cabinet)}`;
    const host=this.closest('product-info');
    host?.updateVariantInputs?.(this.cabinet.id);
    host?.querySelectorAll('a[href]').forEach(link=>{const url=new URL(link.href);if(url.searchParams.has('productpad')){url.searchParams.set('variant',this.cabinet.id);url.searchParams.set('artikel',this.cabinet.sku);url.searchParams.set('uitvoering',this.cabinet.options.join(' / '));link.href=url.toString();}});
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    if (sku) { sku.replaceChildren(this.node('span','',`${this.labels.article}: ${this.cabinet.sku}${this.cabinet.barcode ? ' · EAN: '+this.cabinet.barcode : ''}`)); }
    this.querySelector('[data-exception]').hidden = !(currentWidth === 120 && this.cabinet.sku.startsWith('2x'));
    this.querySelector('[data-notice]').hidden = true;
    const basins = this.querySelector('[data-basins]'); basins.replaceChildren();
    const none = this.radio('basin','none',!this.basin,this.labels.none,()=>{this.basin=null;this.render();this.updateURL();},'regn-mm-config__basin regn-mm-config__basin--none');
    const noneBody = this.node('span','regn-mm-config__card-body');noneBody.append(this.node('strong','',this.labels.none),this.node('small','',this.labels.none_note)); none.append(noneBody);basins.append(none);
    this.compatible().filter(v=>this.tapHoles(v)===0).forEach(v => {
      const title = this.basinTitle(v);
      const card = this.radio('basin',String(v.id),(this.basin?.id === v.id || this.sameBasin(this.basin,v)),`${title} · ${this.money(v.price)}`,()=>{this.basin=v;this.render();this.updateURL();},'regn-mm-config__basin');
      const img = document.createElement('img');img.src=v.image;img.alt=title;img.loading='lazy';img.width=120;img.height=100;
      const material=v.kind==='board'?this.labels.board_note:(v.handle.includes('arq') ? this.labels.solid : this.labels.ceramic);
      const body=this.node('span','regn-mm-config__card-body');body.append(this.node('strong','',title),this.node('small','',`${v.options.filter(o=>!(/kraangat|kraangaten/.test(o))).join(' · ')} · ${material}`),this.node('b','',`+ ${this.money(v.price)}`));
      card.append(img,body,this.node('span','regn-mm-config__tick','✓'));basins.append(card);
    });
    if(!this.compatible().length)basins.append(this.node('p','regn-mm-config__hint',this.labels.empty));
    this.renderTapHoles();
    const tallContainer=this.querySelector('[data-tall]');tallContainer.replaceChildren();
    const noTall=this.radio('tall','none',!this.tall,this.labels.no_tall,()=>{this.tall=null;this.render();this.updateURL();},'regn-mm-config__basin regn-mm-config__basin--none');
    noTall.append(this.node('strong','',this.labels.no_tall));tallContainer.append(noTall);
    this.matchingTalls().forEach(tall=>{
      const direction=tall.options.includes('Links')?this.labels.left:this.labels.right;
      const label=this.radio('tall',String(tall.id),this.tall?.id===tall.id,`${this.labels.tall_short} · ${direction}`,()=>{this.tall=tall;this.render();this.updateURL();},'regn-mm-config__basin');
      if(tall.image){const img=document.createElement('img');img.src=tall.image;img.alt=this.data.tall.title;img.width=64;img.height=80;img.loading='lazy';label.append(img);}
      const body=this.node('span','regn-mm-config__card-body');body.append(this.node('strong','',this.data.tall.title),this.node('small','',`${this.color(tall)} · ${direction}`),this.node('b','',`+ ${this.money(tall.price)}`));label.append(body);tallContainer.append(label);
    });
    if(!this.matchingTalls().length)tallContainer.append(this.node('p','regn-mm-config__hint',this.labels.unavailable));
    this.renderSummary();
  }
  basinTitle(v) { return this.labels.board; }
  renderSummary() {
    const summary=this.querySelector('[data-summary]');summary.replaceChildren();
    const rows=[[this.labels.cabinet, this.cabinet, `${this.cabinet.options.join(' · ')}`]];
    if(this.basin)rows.push([this.basin.kind==='board'?this.labels.board:this.labels.basin_short,this.basin,this.basinTitle(this.basin)+(this.basin.kind==='board'?'':' · '+this.labels['holes_'+this.tapHoles(this.basin)])]);
    if(this.tall)rows.push([this.labels.tall_short,this.tall,`${this.color(this.tall)} · ${this.tall.options.includes('Links')?this.labels.left:this.labels.right}`]);
    rows.forEach(([name,v,detail])=>{const row=this.node('div');const dt=this.node('dt','',name);dt.append(this.node('small','',detail));row.append(dt,this.node('dd','',this.money(v.price)));summary.append(row);});
    const quantityInput=this.querySelector('[data-quantity]');const quantity=quantityInput.valueAsNumber;
    this.querySelector('[data-total]').textContent=this.money(rows.reduce((sum,row)=>sum+row[1].price,0)*(Number.isInteger(quantity)&&quantity>0?quantity:1));
    this.querySelector('[data-add]').disabled = Boolean(this.busy) || !this.cabinet.available || !quantityInput.validity.valid || !Number.isInteger(quantity);
    this.sticky.querySelector('[data-sticky-total]').textContent=this.querySelector('[data-total]').textContent;
    this.sticky.querySelector('[data-sticky-choice]').textContent=`${this.cabinet.options.join(' · ')}${this.basin?' + '+this.basinTitle(this.basin):''}`;
    this.sticky.querySelector('[data-sticky-add]').disabled=this.querySelector('[data-add]').disabled;
  }
  updateURL() {
    const url=new URL(location.href);url.searchParams.set('variant',this.cabinet.id);
    this.basin?url.searchParams.set('regn_board',this.basin.id):url.searchParams.delete('regn_board');
    this.tall?url.searchParams.set('regn_tall',this.tall.id):url.searchParams.delete('regn_tall');
    history.replaceState({},'',url);
  }
  async add() {
    if(this.busy)return;
    const input=this.querySelector('[data-quantity]');if(!input.reportValidity())return;
    if(!this.cabinet.available || (this.basin && !this.compatible().some(v=>v.id===this.basin.id)) || (this.tall && !this.matchingTalls().some(v=>v.id===this.tall.id)))return;
    this.busy=true;const button=this.querySelector('[data-add]');button.disabled=true;button.textContent=this.labels.adding;
    this.sticky.querySelector('[data-sticky-add]').disabled=true;
    const error=this.querySelector('[data-error]');error.hidden=true;
    this.querySelectorAll('input').forEach(i=>i.disabled=true);
    const root=window.Shopify?.routes?.root || '/';
    const items=[this.cabinet,this.basin,this.tall].filter(Boolean).map(v=>({id:v.id,quantity:input.valueAsNumber}));
    if(this.basin && this.tapHoles(this.basin)>0){
      const line=items.find(v=>v.id===this.basin.id);
      line.properties={'Bewerking':`${this.tapHoles(this.basin)} × kraangat (0102001)`};
    }
    try{
      const response=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
      if(!response.ok)throw new Error('cart');
      const result=await response.json();if(!result.items?.length)throw new Error('cart');
      location.assign(`${root}cart`);
    }catch{
      this.busy=false;this.render();input.disabled=false;
      button.textContent=this.labels.add;error.textContent=this.labels.error;error.hidden=false;
    }
  }
}
if(!customElements.get('regn-furniture'))customElements.define('regn-furniture',RegnFurniture);
  } catch(e) { console.error(e); }
})();

})();
